import React from 'react'
import './home.css'
import BigButton from '../utils/BigButton/BigButton'
import { Link } from 'react-router-dom'
import { useLangContext } from '../../Context/LangContext'
import homeTexts from '.././utils/Texts/homeTexts.json'
import { Icon } from '@iconify/react'
import MobileVideo from './video/AFZ02VERTICAL.mp4'
import { useEffect } from 'react'

const HomeMobile = () => {
  const { selectedLanguage } = useLangContext()
  const text = homeTexts[selectedLanguage]

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div className="homeBackgound">
      <video autoPlay playsInline muted className="home-video">
        <source src={MobileVideo} type="video/mp4" />
      </video>
      <div className="gradient">
        <div className="hero-mobile">
          <div className="homeTitle-mobile">
            <h1>
              {text.title1}
              <br />
              {text.title2}
            </h1>
            <div className="BLogo-box-mobile">
              <img
                serc
                src="img/Empressa-Certificada-Logo-White-RGB.png"
                alt="Empresa Certificada Logo"
                className="BLogo-mobile"
              />
            </div>
          </div>
          <div className="call-to-action-container">
            <div className="call-to-action-box">
              <div className="call-texts">
                <h2>
                  {text.callToAction}
                </h2>
                <h4>
                  {text.callSubtitle}
                </h4>
              </div>
              <Link to="/cotizador-alquiler">
                <button className="call-button">
                  {text.callButton}
                  <Icon icon="mdi:arrow-right" className="call-arrow" />
                </button>
              </Link>
            </div>
            <div className="mobile-button-box">
              <Link to="/cotizador-directores">
                <BigButton
                  className="dark-button-mobile-home"
                  name={text.contactButton}
                />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default HomeMobile
